<template>
  <b-modal 
    v-model="visible"
    title="Potwierdź usunięcie materiału">
    <p class="my-4">Czy napewno chcesz usunąć materiał <b>{{item && item.name}}</b>?</p>
    <template v-slot:modal-footer="{cancel}">
      <b-button :disabled="isBusy" size="md" variant="primary" @click="ok">Tak</b-button>
      <b-button :disabled="isBusy" size="md" variant="outline-danger" @click="hide">Nie</b-button>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: "removeMaterialModal",
  data() {
    return {
      visible: false,
      item: null,
      isBusy: false
    }
  },
  methods: {
    show(item) {
      this.item = item;
      this.visible = true;
      this.isBusy = false;
    },
    hide() {
      this.item = null;
      this.visible = false;
    },
    ok() {
      this.isBusy = true;
      this.$emit('ok', this.item);
    },
    error(error) {
      this.isBusy = false;
      console.error(error);
    }
  }
};
</script>